/**
 * @module formatter
 */

/**
 * random produce a string with regexp `^([a-z0-9]){length}$`
 * @param length 
 */
export function randomHash(length: number = 13): string {
	return Array
		.from({ length })
		.map(() => (Math.floor(Math.random() * 36).toString(36)))
		.join('');
}
